module.exports = __webpack_public_path__ + "img/loan-failure.f06fd9a4.svg";